export const YYYY_MM_DD = 'yyyy-MM-dd';
export const YYYY_MM_DD_HH_SS = 'yyyy-MM-dd-HH-ss';
export const YYYYMMDDHH_SS = 'yyyyMMddHHss';
export const DD_MM_YY_HH_MM = 'dd-MM-yy HH:mm';
export const MMM_D = 'MMM d';
